import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'antd';
import NewFolderModel from "./NewFolderModel";
import BaseComponent from "../../../base/BaseComponent";


export default class NewFolder  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {
    }
    componentDidMount() {
    }

    render() {


        return(
            <div> <Button style={{marginRight: 5}} icon={"folder-add"}
                           onClick={(e) => this.createStorageDirectory(e)} >新建文件夹</Button>
            <NewFolderModel  onRef={(newFolder)=>this.setNewFolder = newFolder}  callBack={(currentId,current,checkArray)=>{
                // this.props.callBack&&this.props.callBack(currentId,current,checkArray,true,true)
                this.props.callBack&&this.props.callBack()
            }}></NewFolderModel>
            </div>
        )
    }

    createStorageDirectory(){
        this.props.hideCallBack&&this.props.hideCallBack();
        this.setNewFolder.show(true,'新建文件夹',this.props.currentId,this.props.current,[],true)
    }

}
